import React from 'react'

const HomeWorkingProcess = () => {
    return (
        <>

            <div className="counter-area pt-40 pb-40" style={{ marginTop: "" }}>
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-6 col-lg-4 col-xl-4">
                            <div className="counter-box wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="icon">
                                    <img src="assets/img/icon/solar.svg" alt />
                                </div>
                                <div className="content">
                                    <div className="info">
                                        <span className="counter" data-count="+" data-to={150} data-speed={3000}>09+</span>
                                        <span className="unit"></span>
                                    </div>
                                    <h6 className="title">Projects Done</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4">
                            <div className="counter-box wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="icon">
                                    <img src="assets/img/icon/rating.svg" alt />
                                </div>
                                <div className="content">
                                    <div className="info">
                                        <span className="counter" data-count="+" data-to={25} data-speed={3000}>09+</span>
                                        <span className="unit"></span>
                                    </div>
                                    <h6 className="title">Happy Clients</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4">
                            <div className="counter-box wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="icon">
                                    <img src="assets/img/icon/staff.svg" alt />
                                </div>
                                <div className="content">
                                    <div className="info">
                                        <span className="counter" data-count="+" data-to={120} data-speed={3000}>05+</span>
                                        <span className="unit"></span>
                                    </div>
                                    <h6 className="title">Experts Staff</h6>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="counter-box wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="icon">
                                    <img src="assets/img/icon/award.svg" alt />
                                </div>
                                <div className="content">
                                    <div className="info">
                                        <span className="counter" data-count="+" data-to={50} data-speed={3000}>5+</span>
                                        <span className="unit"></span>
                                    </div>
                                    <h6 className="title">Win Awards</h6>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

        </>
    )
}

export default HomeWorkingProcess